
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.333A6.67 6.67 0 0114.667 8 6.67 6.67 0 018 14.666 6.67 6.67 0 011.333 8 6.67 6.67 0 018 1.333zm0 12A5.332 5.332 0 0013.333 8 5.332 5.332 0 008 2.666 5.332 5.332 0 002.667 8 5.332 5.332 0 008 13.333zM10.357 4.7l.943.943-3.3 3.3L7.057 8l3.3-3.3z","fill":"#2B2B2B"}})])
          )
        }
      }
    